module.exports = __webpack_public_path__ + "static/media/cart-simple1.e9b0cce5.svg";